import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { TextField, Button, Typography, Container, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import FormCard from './FormCard';

function VisitanteForm({ onVisitanteAdded, initialData, onCancelEdit }) {
  const { user } = useAuth();
  const [id, setId] = useState(null);
  const [empresa_id, setEmpresaId] = useState('');
  const [imovel_id, setImovelId] = useState('');
  const [pessoa_id, setPessoaId] = useState('');
  const [data_agendamento, setDataAgendamento] = useState('');
  const [hora_agendamento, setHoraAgendamento] = useState('');
  const [empresas, setEmpresas] = useState([]);
  const [imoveis, setImoveis] = useState([]);
  const [pessoas, setPessoas] = useState([]);

  useEffect(() => {
    if (user && user.tipo_usuario === 'admin') {
      api.get('/empresas')
        .then((response) => setEmpresas(response.data.data || response.data))
        .catch((error) => console.error('Erro ao buscar empresas:', error));
    }

    if (user && user.tipo_usuario === 'padrao') {
      api.get('/visitantes/options')
        .then((response) => {
          setImoveis(response.data.imoveis || []);
          setPessoas(response.data.pessoas || []);
        })
        .catch((error) => console.error('Erro ao buscar opcoes de visitante:', error));
    } else {
      api.get('/imoveis')
        .then((response) => setImoveis(response.data.data || response.data))
        .catch((error) => console.error('Erro ao buscar im\u00F3veis:', error));

      api.get('/pessoas')
        .then((response) => setPessoas(response.data.data || response.data))
        .catch((error) => console.error('Erro ao buscar pessoas:', error));
    }

    if (initialData) {
      setId(initialData.id);
      setEmpresaId(initialData.empresa_id);
      setImovelId(initialData.imovel_id);
      setPessoaId(initialData.pessoa_id);
      setDataAgendamento(initialData.data_agendamento ? initialData.data_agendamento.split('T')[0] : '');
      setHoraAgendamento(initialData.hora_agendamento || '');
    } else {
      clearForm();
    }
  }, [initialData, user]);

  useEffect(() => {
    if (user?.tipo_usuario === 'padrao' && !initialData && imoveis.length === 1) {
      setImovelId(imoveis[0].id);
    }
  }, [user, initialData, imoveis]);

  const clearForm = () => {
    setId(null);
    setEmpresaId('');
    setImovelId('');
    setPessoaId('');
    setDataAgendamento('');
    setHoraAgendamento('');
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const visitanteData = {
      empresa_id: user.tipo_usuario === 'admin' ? empresa_id : user.empresa_id,
      imovel_id,
      pessoa_id,
      data_agendamento: data_agendamento || null,
      hora_agendamento: hora_agendamento || null,
    };

    if (id) {
      api.put(`/visitantes/${id}`, visitanteData)
        .then(() => {
          clearForm();
          onVisitanteAdded();
          onCancelEdit();
        })
        .catch((error) => {
          console.error('Erro ao atualizar visitante:', error);
        });
    } else {
      api.post('/visitantes', visitanteData)
        .then(() => {
          clearForm();
          onVisitanteAdded();
        })
        .catch((error) => {
          console.error('Erro ao adicionar visitante:', error);
        });
    }
  };

  return (
    <Container maxWidth="sm">
      <FormCard component="form" onSubmit={handleSubmit}>
        <Typography variant="h5" gutterBottom>
          {id ? 'Editar Visitante' : 'Adicionar Novo Visitante'}
        </Typography>

        {(user && user.tipo_usuario === 'admin') && (
          <FormControl fullWidth margin="normal" required>
            <InputLabel id="empresa-select-label">Empresa</InputLabel>
            <Select
              labelId="empresa-select-label"
              value={empresa_id}
              label="Empresa"
              onChange={(e) => setEmpresaId(e.target.value)}
              disabled={!!initialData}
            >
              {empresas.map((emp) => (
                <MenuItem key={emp.id} value={emp.id}>
                  {emp.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <FormControl fullWidth margin="normal" required>
          <InputLabel id="imovel-select-label">Im\u00F3vel</InputLabel>
          <Select
            labelId="imovel-select-label"
            value={imovel_id}
            label="Im\u00F3vel"
            onChange={(e) => setImovelId(e.target.value)}
            disabled={!!initialData || user?.tipo_usuario === 'padrao'}
          >
            {imoveis.map((imov) => (
              <MenuItem key={imov.id} value={imov.id}>
                {imov.descricao} - {imov.numero}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal" required>
          <InputLabel id="pessoa-select-label">Pessoa</InputLabel>
          <Select
            labelId="pessoa-select-label"
            value={pessoa_id}
            label="Pessoa"
            onChange={(e) => setPessoaId(e.target.value)}
            disabled={!!initialData}
          >
            {pessoas.map((p) => (
              <MenuItem key={p.id} value={p.id}>
                {p.nome}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Data de Agendamento"
          variant="outlined"
          fullWidth
          type="date"
          value={data_agendamento}
          onChange={(e) => setDataAgendamento(e.target.value)}
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />

        <TextField
          label="Hora de Agendamento"
          variant="outlined"
          fullWidth
          type="time"
          value={hora_agendamento}
          onChange={(e) => setHoraAgendamento(e.target.value)}
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />

        <Button type="submit" variant="contained" color="primary" sx={{ mt: 2, mr: 2 }}>
          {id ? 'Atualizar Visitante' : 'Adicionar Visitante'}
        </Button>
        <Button type="button" variant="outlined" color="secondary" sx={{ mt: 2 }} onClick={onCancelEdit}>
          Cancelar
        </Button>
      </FormCard>
    </Container>
  );
}

export default VisitanteForm;

